import Keycloak from 'keycloak-js';
import { env } from '../../env.js';
import CustomerContextService from '../customerContextService/CustomerContextService';

const keycloak = new Keycloak({
    clientId: env.REACT_APP_KEYCLOAK_CLIENT_ID,
    realm: 'login',
    url: env.REACT_APP_KEYCLOAK_URL,
    publicClient: true,
});

const initKeycloak = (onAuthenticatedCallback) => {
    keycloak
        .init({
            onLoad: 'check-sso',
            silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
            pkceMethod: 'S256',
            checkLoginIframe: true,
        })
        .then((authenticated) => {
            if (authenticated) {
                onAuthenticatedCallback();
                startSessionCheck();
            } else {
                doLogin();
            }
        });
};

const doLogin = keycloak.login;

const doLogout = (options) => {
    CustomerContextService.clearStoredCustomerUuid();
    return keycloak.logout(options);
};

const getToken = () => keycloak.token;

const isLoggedIn = () => !!keycloak.token;

const updateToken = (successCallback) => keycloak.updateToken(5).then(successCallback).catch(doLogin);

const getUsername = () => keycloak.tokenParsed?.preferred_username;

const getTenantId = () => keycloak.tokenParsed?.tenant_id;

const getMail = () => keycloak.tokenParsed?.email;

const getFamilyName = () => keycloak.tokenParsed?.family_name;

const getGivenName = () => keycloak.tokenParsed?.given_name;

const getTokenParsed = () => keycloak.tokenParsed;

const hasRole = (roles) => roles.some((role) => keycloak.hasRealmRole(role));

const startSessionCheck = () => {
    // Check every minute if the session is still valid
    setInterval(() => {
        keycloak.updateToken(5).catch(() => {
            doLogout();
        });
    }, 60000);
};

const UserService = {
    initKeycloak,
    doLogin,
    doLogout,
    isLoggedIn,
    getToken,
    updateToken,
    getUsername,
    getTenantId,
    hasRole,
    getMail,
    getFamilyName,
    getGivenName,
    getTokenParsed,
};

export default UserService;
